import React from "react";

/**
 * Badge de la carte devis (page Dossier) : un reste à charge NÉGATIF (aide déduite supérieure au TTC) est AFFICHÉ, jamais masqué (décision CTO 15/10).
 * Le montant vient du serveur (`reste_a_charge`, relu des lignes pour un brouillon) : l'écran ne calcule rien. Paire contrastée --oh-error-* (clair + foncé).
 */
export default function RacNegatifDevis({ devis, formatMontant }) {
  const rac = Number(devis?.reste_a_charge);
  if (!Number.isFinite(rac) || rac >= 0) return null;
  return (
    <p
      className="text-sm font-medium rounded-lg px-2 py-1 mt-1"
      style={{ background: "var(--oh-error-bg)", color: "var(--oh-error-text)", border: "0.5px solid var(--oh-error-border)" }}
      data-testid="devis-rac-negatif"
    >
      Reste à charge négatif : aide supérieure au TTC ({formatMontant(rac)})
    </p>
  );
}
